import { render, staticRenderFns } from "./monitoring2PrintLable.vue?vue&type=template&id=12dcef42"
import script from "./monitoring2PrintLable.vue?vue&type=script&lang=js"
export * from "./monitoring2PrintLable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports